<ion-item class="no-lines">
  <ion-label>
    <p class="message" [innerHTML]="actionMessage"></p>
  </ion-label>
</ion-item>
